// In production, use relative URLs (empty string means relative to current domain)
// In development, use localhost
const getApiUrl = () => {
  // Check production mode FIRST - always use relative URLs in production
  if (import.meta.env.PROD) {
    const envApiUrl = import.meta.env.VITE_API_URL
    // Only override with env variable if it's explicitly set to a non-empty value
    if (envApiUrl && envApiUrl.trim() !== '') {
      return envApiUrl
    }
    return '' // Always use relative URLs in production by default
  }
  // In development: use env variable or default to localhost
  return import.meta.env.VITE_API_URL || 'http://localhost:3000'
}

export const env = {
  apiUrl: getApiUrl(),
  apiTimeout: Number(import.meta.env.VITE_API_TIMEOUT) || 30000,
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY || '',
} as const

export type Env = typeof env

